import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { SettingsDrawer } from './SettingsDrawer'

function Layout() {
  const [settingsOpen, setSettingsOpen] = React.useState(false)
  const location = useLocation()
  const hideSettings = location.pathname === "/demo/products"

  return (
    <main className="h-screen">
      {!hideSettings && (
        <>
          <button
            type="button"
            onClick={() => setSettingsOpen(true)}
            className="fixed top-3 right-3 z-50 px-3 py-1 text-xs rounded border"
            title="Settings"
          >
            Settings
          </button>
          <SettingsDrawer open={settingsOpen} onClose={() => setSettingsOpen(false)} />
        </>
      )}
      <Outlet />
    </main>
  )
}

export default Layout 